import { render, staticRenderFns } from "./WorkContactReadonlyLayout.vue?vue&type=template&id=2015483a&scoped=true"
import script from "./WorkContactReadonlyLayout.vue?vue&type=script&lang=js"
export * from "./WorkContactReadonlyLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkContactReadonlyLayout.vue?vue&type=style&index=0&id=2015483a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015483a",
  null
  
)

export default component.exports